import * as React from "react"
import { NavLink } from 'react-router-dom';

const CustomizeBar = () => {
	const paddingY = 'py-1';

	const beforeS = ` font-roboto  focus:shadow-none text-base py-1 px-3 current:bg-green-50 current:bg-opacity-40 hover:before:bg-slate-300   before:left-0 before:h-[3px] before:w-full before:bottom-[-6px] before:absolute before:current:bg-green-400`;

	return (
		<>
			<nav className="bg-white">
				<ul
					className={ ` pl-3 ${ paddingY } border-b-2 border-gray-100 flex gap-4  ` }
				>
					<li className="relative m-0  ">
						<NavLink
							className={ `current:text-green-600   ${ beforeS } ` }
							to={ 'timetable' }
							end
						>
							TimeTable
						</NavLink>
					</li>
					<li className="relative m-0 ">
						<NavLink
							className={ `current:text-green-600  ${ beforeS } ` }
							to={ 'printerpage' }
						>
							PrinterPage
						</NavLink>
					</li>
					<li className="relative m-0 ">
						<NavLink
							className={ `current:text-green-600  ${ beforeS } ` }
							to={ 'location' }
						>
							Location
						</NavLink>
					</li>
				</ul>
			</nav>
		</>
	);
};

export default CustomizeBar;
